import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HourglassFullOutlinedIcon from "@mui/icons-material/HourglassFullOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { ReactComponent as WP } from "../GlobalAssets/svg/WP.svg";
import { ReactComponent as InstallType } from "../GlobalAssets/svg/InstallType.svg";
import { ReactComponent as PHP } from "../GlobalAssets/svg/PHP.svg";
import { ReactComponent as IPAddress } from "../GlobalAssets/svg/IPAddress.svg";
import { ReactComponent as StorageSites } from "../GlobalAssets/svg/StorageSites.svg";
import { ReactComponent as BandwidthSites } from "../GlobalAssets/svg/BandwidthSites.svg";
import { ReactComponent as SiteVisits } from "../GlobalAssets/svg/SiteVisits.svg";
import { Grid2 } from "@mui/material";

export const Regex = {
  email:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  domain:
    /(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/,
};

export function verifyPassword(value) {
  var passRex =
    /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[*.!@$%^&(){}[\]:;<>,.?~_+\-=|])[A-Za-z0-9*.!@$%^&(){}[\]:;<>,.?~_+\-=|]{8,32}$/;
  return passRex.test(value);
}

export const verifyEmail = (value) => {
  var emailRex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (emailRex.test(value)) {
    return true;
  }
  return false;
};

export const STAGING = {
  LIVE: "LIVE",
  DEV: "STAGING",
};

export const FEATURES = {
  STORAGE: "STORAGE",
  BANDWIDTH: "BANDWIDTH",
  VISIT: "VISIT",
};

export const fileStatusConfig = {
  done: {
    label: "Done",
    icon: <CheckCircleIcon />,
    color: "#2AC078",
  },
  pending: {
    label: "Pending",
    icon: <HourglassFullOutlinedIcon />,
    color: "#ffa500",
  },
};

export const fileColumns = [
  { id: "name", label: "Name" },
  { id: "size", label: "Size" },
  { id: "create", label: "Create" },
  { id: "download", label: "Download" },
];

export const devtoolsStatusConfig = {
  active: {
    label: "Active",
    icon: <CheckCircleIcon />,
    color: "#2AC078",
  },
  rejected: {
    label: "Rejected",
    icon: <CloseOutlinedIcon />,
    color: "#ff0000",
  },
  pending: {
    label: "Pending",
    icon: <HourglassFullOutlinedIcon />,
    color: "#ffa500",
  },
};

export const devToolsColumns = [
  { id: "host", label: "Host" },
  { id: "name", label: "User Name" },
  { id: "port", label: "Port" },
];

export const adminApi = (item, site, live, staging) => {
  if (item === "wp") {
    if (live) {
      if (staging) {
        window.open(
          `https://${live + "." + process.env.REACT_APP_TEMP_DOMAIN}/wp-admin`,
          "_blank"
        );
      } else {
        window.open(`https://${live}/wp-admin`, "_blank");
      }
    } else {
      window.open(
        `https://${site + "." + process.env.REACT_APP_TEMP_DOMAIN}/wp-admin`,
        "_blank"
      );
    }
  } else if (item === "php") {
    window.open(
      `https://dbadmin.${process.env.REACT_APP_TEMP_DOMAIN}/`,
      "_blank"
    );
  } else if (item === "domain") {
    if (live) {
      if (staging) {
        window.open(
          `https://${live + "." + process.env.REACT_APP_TEMP_DOMAIN}`,
          "_blank"
        );
      } else {
        window.open(`https://${live}`, "_blank");
      }
    } else {
      window.open(
        `https://${site + "." + process.env.REACT_APP_TEMP_DOMAIN}`,
        "_blank"
      );
    }
  }
};

const urlPath = window.location.pathname;
const segments = urlPath.split("/");
export const orgIdURL = segments[2];
export const siteNameURL = segments[3];

export const domainColumns = [
  { id: "domain", label: "Domain Name" },
  { id: "dns", label: "DNS" },
  { id: "ssl", label: "SSL" },
  { id: "expiration", label: "SSL Expiration" },
  { id: "primary", label: "Primary" },
];

export const domainStatusConfig = {
  active: {
    label: "Active",
    icon: <CheckCircleOutlineOutlinedIcon />,
    color: "#2AC078",
  },
  inactive: {
    label: "InActive",
    icon: <CancelOutlinedIcon />,
    color: "#ff0000",
  },
  golive: {
    label: "Go Live",
    icon: <CheckCircleIcon />,
    color: "#2AC078",
  },
};

export const alertStatusConfig = {
  download: {
    label: "Download",
    icon: <CheckCircleIcon />,
    color: "#2AC078",
  },
  failed: {
    label: "Failed",
    icon: <CloseOutlinedIcon />,
    color: "#ff0000",
  },
  pending: {
    label: "Pending",
    icon: <HourglassFullOutlinedIcon />,
    color: "#ffa500",
  },
};

export const alertcolumns = [
  { id: "dateTime", label: "Date & Time" },
  { id: "alertType", label: "Alert Type" },
  { id: "severity", label: "Severity" },
  { id: "downloadLogFile", label: "Download Log File" },
];

export const CP = {
  SIZE: 18,
  COLOR: "inherit",
};

export const tools = {
  PHP: "php",
  WP: "wp",
  DOMAIN: "domain",
  CACHE: "cache",
  DEBUG: "debug",
  WAF: "waf",
  SFTP: "sftp",
};

const stepStyle = {
  color: "#4C4C4D",
  fontFamily: "Nunito",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: "500",
  lineHeight: "normal",
  // Dark theme override
  [`[data-theme="dark"] &`]: {
    color: "#fff",
  },
};

const siteStyle = {
  color: "#4C4C4D",
  fontFamily: "Nunito",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: "600",
  lineHeight: "normal",
  // Dark theme override
  [`[data-theme="dark"] &`]: {
    color: "#fff",
  },
};

export const EmptyStateForSite = {
  header: "Get Started with Site",
  subHeader:
    "Our guided setup helps you quickly launch a fully customizable WordPress site, tailored to your specific needs with the right themes, templates, and plugins.",
  title: "Launch Your Custom WordPress Site with Ease",
  subTitle:
    "Ready to bring your vision to life online? With our step-by-step guidance, launching your WordPress site has never been easier. Choose from a wide range of pre-built templates, themes, and plugins that best suit your goals. Whether you’re building from scratch or customizing an existing design, we make it simple to get your site up and running quickly.",
  create: "Create Site",
  title1: "How do you create a Site?",
  subTitle1: (
    <>
      <span style={stepStyle}>Step 1:</span> Select Create Site, select
      <span style={siteStyle}> "New WordPress Site"</span>, and select your
      preferred WordPress site.
    </>
  ),
  subTitle2: (
    <>
      <span style={stepStyle}>Step 2:</span> Choose your
      <span style={siteStyle}> Site type</span> and
      <span style={siteStyle}> Installation type</span>, then enter your
      WordPress login details.
    </>
  ),
  subTitle3: (
    <>
      <span style={stepStyle}>Step 3:</span> Review the details carefully, and
      then click on
      <span style={siteStyle}> “Create”</span> to complete the process.
    </>
  ),
  docsheader: "Looking for detailed, step-by-step help in creating a site?",
  docsSubheader:
    "Our Rocon documentation provides a clear, step-by-step guide to help you effortlessly create your blueprint.",
  docsbutton: "Rocon Docs",
  liveHeader: "Still Need Help Creating a Site?",
  liveSubheader:
    "Reach out to our award-winning support team for person-to-person help 24 hours a day, 7 days a week, 365 days a year.",
  liveButton: "Live Chat",
};

export const NewEmptyStateForSite = {
  header: "Build and Launch Your WordPress Site Today",
  subHeader:
    "Choose from ready-to-use templates, themes, and plugins to create a site that meets your needs. No hassle, just results.",
  title: "Get Your WordPress Site Live Today",
  subTitle:
    "Create a WordPress site tailored to your goals. Our streamlined setup process lets you choose from templates, themes, and plugins to get your site live quickly. Whether building from scratch or customizing pre-built options, starting your online journey has never been easier!",
};

export const EmptyStateForBlueprints = {
  header: "Get Started with Blueprint",
  subHeader:
    "Blueprints allow you to create reusable templates of your site's themes and plugins, eliminating the need to set everything up from scratch",
  title: "Create Shared Theme and Plugin Templates",
  subTitle:
    "Streamline your workflow by using Blueprints to build WordPress sites faster. Save your themes and plugins as reusable templates for future projects. When starting a new site, choose a Blueprint to avoid rebuilding from scratch, ensuring consistency and efficiency in your development process. Streamline your workflow by using Blueprints to build WordPress sites faster. Save your themes and plugins as reusable templates for future projects.",
  title1: "How do you create a Blueprint?",
  subTitle1: (
    <>
      <span style={stepStyle}>Step 1:</span> Select
      <span style={siteStyle}> “Create Blueprint”</span>, from the dropdown
      menu, choose the site you want to use as the base for your blueprint.
    </>
  ),
  subTitle2: (
    <>
      <span style={stepStyle}>Step 2:</span> Enter a descriptive name for your
      blueprint in the
      <span style={siteStyle}> “Blueprint Nickname” </span>field. This will help
      you easily identify the blueprint for future use.
    </>
  ),
  subTitle3: (
    <>
      <span style={stepStyle}>Step 3:</span> The optional step is to upload an
      image <br /> (220x120 pixels, less than 1MB) and click
      <span style={siteStyle}> “Create” </span>to finalize.
    </>
  ),
  create: "Create Blueprint",
  docsheader:
    "Looking for detailed, step-by-step help in creating a blueprint?",
  docsSubheader:
    "Our Rocon documentation provides a clear, step-by-step guide to help you effortlessly create your blueprint.",
  docsbutton: "Rocon Docs",
  liveHeader: "Still Need Help Creating a Blueprint?",
  liveSubheader:
    "Reach out to our award-winning support team for person-to-person help 24 hours a day, 7 days a week, 365 days a year.",
  liveButton: "Live Chat",
};

export const NewEmptyStateForBlueprints = {
  header: "Get Started with Blueprints",
  subHeader: "Accelerate Your WordPress Site Creation with Modern Templates",
  title: "Build Smarter with Blueprint",
  subTitle:
    "Save valuable time by leveraging our Blueprints feature to streamline WordPress site development. Easily save your themes and plugins as reusable templates for future projects. When setting up a new site, choose to start with a Blueprint and eliminate the need to rebuild everything from scratch.",
};

export const EmptyStateForPayments = {
  header: "Select a Plan to Unlock Premium Features",
  subHeader:
    "Discover the right plan and gain access to all the tools you need.",
  title: "Unlock Full Access with LaunchPad",
  subTitle:
    "Maximize your WordPress management experience with LaunchPad. Our plans are designed to give your organization the tools needed for seamless site management, premium features, and efficient team collaboration.",
  create: "Create Site",
};

export const EmptyStateForCilentOrg = {
  header: "Expand Your Space - Create a Client Org Today",
  subHeader:
    "Take full advantage of your plan by creating a client organization today and experience a more structured, scalable, and efficient way to manage your operations!",
  title: "Maximize Efficiency with Client Organizations",
  subTitle:
    "If your organization already has a plan, take it to the next level by creating a client organization. This powerful feature allows you to streamline management, enhance team collaboration, and allocate resources more efficiently, ensuring smoother operations and greater control.",
  title1: "How do you create a Client Organization?",
  subTitle1: (
    <>
      <span style={stepStyle}>Step 1:</span> Initiate the Process -
      <span style={siteStyle}> Click on Create Client Org </span>and select the
      main organization to establish the new client structure.
    </>
  ),
  subTitle2: (
    <>
      <span style={stepStyle}>Step 2:</span> Set Up the Details - Enter the
      <span style={siteStyle}> Client Organization Name </span>and assign key
      team members to ensure smooth operations.
    </>
  ),
  subTitle3: (
    <>
      <span style={stepStyle}>Step 3:</span> Confirm & Launch - Review the setup
      <span style={siteStyle}> "Create" </span>to finalize—your client
      organization is now ready to operate efficiently!
    </>
  ),
  create: "Create Client Org",
  docsheader:
    "Looking for detailed, step-by-step help in creating a client organization?",
  docsSubheader:
    "Our Rocon documentation provides a clear, step-by-step guide to help you effortlessly create your client organization.",
  docsbutton: "Rocon Docs",
  liveHeader: "Still Need Help Creating a Client Organization?",
  liveSubheader:
    "Reach out to our award-winning support team for person-to-person help 24 hours a day, 7 days a week, 365 days a year.",
  liveButton: "Live Chat",
};

export const NewEmptyStateForCilentOrg = {
  header: "Get Started with Cilent Organization",
  subHeader:
    "Easily set up and manage your client organizations in just a few steps.",
  title: "Don’t Miss Out — Activate Your Plan Now!",
  subTitle:
    "Unlock the full potential of your organization by enrolling in a plan today! Gain access to powerful tools, enhanced security, and seamless scalability to support your growth",
};

// Orgs whose new sites are still built on v1 (EFS), so they keep the original create-site
// and add-on options. Same list as V1_SITE_ORG_IDS in rocon-api's JenkinsApiController.
export const V1_SITE_ORG_IDS = [
  1488, 1510, 1511, 1512, 1514, 1515, 1516, 1517, 1518, 1519, 1520, 1521, 1522,
  1523, 1524, 1525,
];

export const buildsV1Sites = (orgId) => V1_SITE_ORG_IDS.includes(Number(orgId));

// SSH for EBS (v2) sites: every site gets one. All sites share one gateway (ssh.<env domain>),
// the site name is the login and the password is chosen at site creation. The create job
// (ebs-Buildsite, ENABLE_SSH + SSH_PASSWORD) keeps only a hash, so the password is shown to
// the owner once, right after creation, and is never stored here. There is no job yet to
// reset it later.
export const EBS_SSH = {
  HOST: `ssh.${process.env.REACT_APP_TEMP_DOMAIN}`,
  PORT: 22,
  // same rules as the WordPress admin password (verifyPassword)
  MIN_PASSWORD_LENGTH: 8,
  GENERATED_PASSWORD_LENGTH: 16,
  // unambiguous letters and digits, plus specials that need no shell quoting in `ssh user@host`
  PASSWORD_CHARS: "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789",
  PASSWORD_SPECIALS: "!@%^*_-+=",
  TITLE: "SSH Access",
  CREATE_TITLE: "SSH & SFTP Access",
  SECTION_SUBTITLE:
    "Your site includes SSH (command line) and SFTP (file transfer) access. Choose one password for both.",
  PASSWORD_TITLE: "SSH & SFTP Password",
  PASSWORD_PLACEHOLDER: "Enter Password",
  PASSWORD_ERROR:
    "Requires at least 8 characters with one capital letter, one numeric character, and one special character",
  PASSWORD_SAME_AS_WP:
    "Choose a password that's different from your WordPress admin password",
  GENERATE: "Generate password",
  SHOW_ONCE_NOTE:
    "Remember this password: it can't be changed or recovered later. Your SSH and SFTP details will be under Dev Tools once the site is ready.",
  NOT_ENABLED: "SSH details aren't available for this site yet.",
  LOCKOUT_NOTE:
    "Too many failed logins in a minute block your IP address for an hour. Idle sessions close after 30 minutes.",
  PASSWORD_NOTE:
    "Use the SSH & SFTP password you chose when the site was created. It can't be changed or recovered.",
  // Dev Tools: how to connect, in order
  STEPS_TITLE: "How to connect",
  STEPS: [
    "Open a terminal: Terminal on Mac, or PowerShell / Command Prompt on Windows.",
    "Copy the command below, paste it into the terminal and press Enter.",
    'The first time, type "yes" when asked whether to trust the host.',
    "Enter your SSH password when prompted (nothing is shown while you type).",
    "You're now in your site's WordPress folder. Try: wp plugin list",
  ],
  PUTTY_NOTE: "Using PuTTY? Host: {host}, Port: 22, login as {username}.",
};

// SFTP for EBS (v2) sites: one login per site (the site name), through the site's own port on
// the shared NLB, with the same password as SSH (chosen at creation, never stored).
export const EBS_SFTP = {
  TITLE: "SFTP Access",
  PASSWORD_NOTE:
    "Use the SSH & SFTP password you chose when the site was created. It can't be changed or recovered.",
  NOT_AVAILABLE: "SFTP isn't available for this site yet.",
  STEPS_TITLE: "How to connect",
  STEPS: [
    "Open your SFTP client (FileZilla, Cyberduck or WinSCP).",
    "Choose the SFTP protocol, then enter the host, port and username shown above.",
    "Enter the password you chose when the site was created and connect.",
    "Your site's files are in the wordpress folder.",
  ],
};

export const sshCommand = (username, host = EBS_SSH.HOST) =>
  `ssh ${username}@${host}`;

// window.crypto.getRandomValues is on every browser and on jsdom; Math.random is only the last resort
export const generateSshPassword = (
  length = EBS_SSH.GENERATED_PASSWORD_LENGTH,
) => {
  const chars = EBS_SSH.PASSWORD_CHARS + EBS_SSH.PASSWORD_SPECIALS;
  const cryptoObj = typeof window !== "undefined" ? window.crypto : undefined;
  const pick = (from, n) => {
    let out = "";
    if (cryptoObj?.getRandomValues) {
      const values = new Uint32Array(n);
      cryptoObj.getRandomValues(values);
      for (let i = 0; i < n; i++) {
        out += from[values[i] % from.length];
      }
    } else {
      for (let i = 0; i < n; i++) {
        out += from[Math.floor(Math.random() * from.length)];
      }
    }
    return out;
  };
  // one of each kind the WordPress password rule asks for, the rest from the whole set
  const required =
    pick("ABCDEFGHJKLMNPQRSTUVWXYZ", 1) +
    pick("abcdefghijkmnpqrstuvwxyz", 1) +
    pick("23456789", 1) +
    pick(EBS_SSH.PASSWORD_SPECIALS, 1);
  const rest = pick(chars, Math.max(length - required.length, 0));
  return (required + rest)
    .split("")
    .sort(() => (pick("01", 1) === "0" ? -1 : 1))
    .join("");
};

// Same rules as the WordPress admin password (and as rocon-api's check before ebs-Buildsite)
export const verifySshPasswordFormat = (value) =>
  typeof value === "string" && verifyPassword(value);

export const verifySshPassword = (value, wordpressPassword) =>
  verifySshPasswordFormat(value) && value !== wordpressPassword;

// Which rule the SSH password breaks, or null when it is fine or still empty
export const sshPasswordErrorMessage = (value, wordpressPassword) => {
  if (!value) return null;
  if (!verifySshPasswordFormat(value)) return EBS_SSH.PASSWORD_ERROR;
  if (value === wordpressPassword) return EBS_SSH.PASSWORD_SAME_AS_WP;
  return null;
};

export const getIconDetailsData = (
  siteData,
  wpVersion,
  wpLatest,
  handleVersionPopup,
  dedicatedHosting
) => {
  return [
    {
      icon: InstallType,
      title: "Install Type",
      subTitle: siteData.installType,
    },
    {
      icon: WP,
      title: "WP Version",
      subTitle: dedicatedHosting ? (
        siteData.instanceWp
      ) : wpVersion && wpLatest > wpVersion ? (
        <>
          <Grid2
            onClick={handleVersionPopup}
            style={{
              cursor: "pointer",
              textDecorationLine: "underline",
              color: "#135fc2",
              fontWeight: "600",
            }}
          >
            Update Version
          </Grid2>
        </>
      ) : (
        <>
          <Grid2>{wpVersion !== "" ? wpVersion : "--"} Version</Grid2>
        </>
      ),
    },
    {
      icon: PHP,
      title: "PHP Version",
      subTitle: `${
        dedicatedHosting ? siteData.instancePhp : siteData.phpVersion
      } Version`,
    },
    {
      icon: IPAddress,
      title: "IP Address",
      subTitle: dedicatedHosting ? siteData.instanceIp : siteData.ipAddress,
      copy: true,
    },
  ];
};

export const icons = (storage, bandwidth, visits, status) => {
  return [
    {
      unit: storage,
      use: "",
      type: "Storage",
      icon: StorageSites,
      status: status === "provision",
    },
    {
      unit: bandwidth,
      use: "",
      type: "Bandwidth",
      icon: BandwidthSites,
      status: status === "provision",
    },
    {
      unit: visits,
      use: "Visits",
      type: "Site Visits",
      icon: SiteVisits,
      status: status === "provision",
    },
  ];
};

export function formatFileSize(bytes) {
  if (bytes === 0 || !bytes) return "0 by";
  const units = ["by", "kb", "mb", "gb", "tb", "pb", "eb", "zb", "yb"];
  const index = Math.floor(Math.log(bytes) / Math.log(1024));
  return `${(bytes / Math.pow(1024, index)).toFixed(1)} ${units[index]}`;
}

export function formatFileSizeCaps(bytes) {
  if (!bytes || typeof bytes !== "number" || bytes < 0) return "0 B"; // Ensure valid input

  const units = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  const index = Math.floor(Math.log(bytes) / Math.log(1024));
  return `${(bytes / Math.pow(1024, index)).toFixed(1)} ${units[index]}`;
}

export const formatDate = (timestamp) => {
  const now = new Date();
  const date = new Date(timestamp);

  const timeDiff = now - date;

  const seconds = Math.floor(timeDiff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  const formattedDate = date.toLocaleDateString();

  let relativeTime = "";
  if (minutes < 60) {
    relativeTime = `${minutes} minute${minutes !== 1 ? "s" : ""} ago`;
  } else if (hours < 24) {
    relativeTime = `${hours} hour${hours !== 1 ? "s" : ""} ago`;
  } else {
    relativeTime = `${days} day${days !== 1 ? "s" : ""} ago`;
  }

  return `${formattedDate}, ${relativeTime}`;
};

export function getApproximateDaysUntilTimestamp(timestampString) {
  const timestamp = new Date(timestampString);
  const currentDate = new Date();
  const differenceInMilliseconds = timestamp - currentDate;
  const differenceInDays = differenceInMilliseconds / (1000 * 60 * 60 * 24);
  const approximateDays = Math.round(differenceInDays);
  return approximateDays;
}

export const formatFilename = () => {
  var date = new Date();
  const d = date.toISOString();
  const cleandate = d.toLowerCase().replace(/[^a-z0-9]fg/g, "-");
  const randomString = Math.random().toString(36).substring(2, 7);
  const newFilename = `${randomString}-${cleandate}`;
  return newFilename.substring(0, 60) + ".json";
};

export default function getAuthorizationHeader() {
  const accessToken = localStorage.getItem("accessToken");
  if (accessToken) {
    return {
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: "Bearer " + accessToken,
      },
    };
  } else {
    throw new Error("Access token not found");
  }
}

export function lastSegmentPath(location) {
  const pathSegments = location.pathname.split("/");
  const lastSegment = pathSegments[pathSegments.length - 1];
  return lastSegment;
}

export const adminApiClick = (item, live) => {
  if (item === "wp") {
    window.open(`https://${live}/wp-admin`, "_blank");
  } else if (item === "php") {
    window.open(
      `https://dbadmin.${process.env.REACT_APP_TEMP_DOMAIN}/`,
      "_blank"
    );
  } else if (item === "domain") {
    window.open(`https://${live}`, "_blank");
  }
};

export const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const isValidDomain = (domain) => {
  const domainRegex =
    /^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,63}$/;
  return domainRegex.test(domain);
};

export const addons_names = {
  WAF: "Waf",
  STAGING: "Staging",
  ADDON: "Additional Site",
  PERFORMANCE: "Performance Sites",
  STORAGE: "Storage",
  // one-time per-site instance upgrade (EBS sites), plan_name in plans_domain
  PERFORMANCE_UPGRADE: "Performance Upgrade",
};
